import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LazyHero from 'react-lazy-hero';
import { Grid } from '@material-ui/core';
import { useSpring, animated } from 'react-spring'
import Typist from 'react-typist';
import './Typist.css'

const useStyles = makeStyles(theme => ({
    normalText: {
      fontSize:'55px',
      background:'rgba(255,192,203,0.5)',
      [theme.breakpoints.down('sm')]: {
        fontSize:'45px',
      },
    },
    ActionText: {
      color:'white',
      fontSize:'55px',
      background:'black',
      [theme.breakpoints.down('sm')]: {
        fontSize:'45px',
      },
    },
    title: {
      flexGrow: 1,
      color:'black'
    },
    container:{
        height:'100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    insideStrip:{
        alignSelf: 'center',
        textAlign:'left',
        lineHeight:'45px',
        width:'75vw',
        height:'150px'
    },
    lazyHero:{
      background:'url(https://res.cloudinary.com/dlvdelwc2/image/upload/v1580702398/test.svg_olimso.svg)'
    }
  }));

  function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

 const backgroundImgs = ['50','59','70','73']
 const img = `/portfolio/images/photos/img${backgroundImgs[getRandomInt(backgroundImgs.length)]}.jpg`

export default function Hero() {
    const classes = useStyles();

    const upAndDown = useSpring({config: { mass: 5,delay:0 },
      from: { transform: 'translate3d(0,-10px,0)' },
      to: async next => {
        while (1) {
          await next({ transform: 'translate3d(0,10px,0)' })
          await next({ transform: 'translate3d(0,-10px,0)' })

        }
      },
    })

    //console.log('renderHero')
    return (
        <LazyHero   imageSrc={img}
                    minHeight="80vh" 
                    opacity={0.6} 
                    parallaxOffset={100} 
                    className={classes.lazyHero}>
          <Grid container justify="space-around">
            <Grid item md={7} sm={12} xs={12}>
              <div className={classes.insideStrip}>
                <Typist key="Test"
                  cursorClassName={classes.cursor} 
                  speed={2} 
                  cursor={{
                  show: true,
                  blink: true,
                  element: '|',
                  hideWhenDone: true,
                  hideWhenDoneDelay: 0,
                }}>
                  <span className={classes.normalText}>Hi, I am Amit <br/> and I love</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className={classes.ActionText}>developing</span>
                  <Typist.Delay ms={1000} />
                  <Typist.Backspace count={10} />
                  <span className={classes.ActionText}>designing</span>
                  <Typist.Delay ms={1000} />
                  <Typist.Backspace count={9} />
                  <span className={classes.ActionText}>taking photos</span>
                  <Typist.Delay ms={1000} />
                  <Typist.Backspace count={13} />
                  <span className={classes.ActionText}>creating</span>
                </Typist> 
              </div>
            </Grid>

            <Grid item md={5} sm={12} xs={12} style={{position: 'relative'}} >
              <div style={{position: 'absolute', fontSize:'35px',
                          top: '50%', left: '50%',
                          transform: 'translate(-50%,-50%)'}}>        
                <animated.div style={upAndDown} >
                  <span role="img" aria-label='peek'>
                    👇🏼
                  </span>
                </animated.div>
              </div>
            </Grid>
          </Grid>
        </LazyHero>
            
       
        
    );
  }